import { Trans } from '@lingui/macro'
import { Alert, Box, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material'
import { CurrencyFormated } from 'app/views/common/Formats'
import { sanitizeLineKey } from './FormBudget'

export const FormBudgetReadOnly = ({ title, value, typeProps }) => {
  const { expensesLines = [], revenuesLines = [] } = typeProps

  if (Object.keys(value.revenues).length === 0) {
    return (
      <>
        <div className='form-print-title'>{title}</div>
        <Alert severity='info'>
          <Trans>There are no lines added to budget of this application</Trans>
        </Alert>
      </>
    )
  }

  const revenuesRender = revenuesLines.map(key => ({
    key,
    ...value.revenues[key]
  }))

  const expensesRender = expensesLines.map(key => ({
    key: sanitizeLineKey(key),
    ...value.expenses[sanitizeLineKey(key)]
  }))

  const totalRevenue = revenuesRender.reduce(
    (sum, obj) => sum + obj.value,
    0
  )

  const totalExpense = expensesRender.reduce(
    (sum, obj) => sum + obj.value,
    0
  )

  const budgetBalance = totalRevenue - totalExpense

  return (
    <Box sx={{ backgroundColor: '#EEEEE657' }}>
      <Box className='form-print-title'>{title}</Box>
      <TableContainer
        component={Box}
        sx={{
          mx: '-16px',
          width: 'calc(100% + 32px)',
          backgroundColor: '#ffffff',
          borderTop: 'none'
        }}
      >
        <Table
          aria-label='simple table'
          sx={{
            width: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'collapse',
            '& td, & th': {
              borderBottom: '1.5px solid #EEEFE6'
            }
          }}
        >
          <TableHead
            sx={{
              backgroundColor: '#fff',
              borderTop: 'none',
              borderBottom: '2.5px solid #EEEFE6'
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  width: '25%',
                  px: '40px',
                  paddingTop: '24px',
                  paddingBottom: '16px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <Trans>Revenues</Trans>
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: '25%',
                  paddingLeft: '20px',
                  paddingRight: '5px'
                }}
              >
                <Typography className='form-print-small-label'>
                  <Trans>Value</Trans>
                </Typography>
              </TableCell>
              <TableCell sx={{ width: '50%', px: '40px' }}>
                <Typography className='form-print-small-label'>
                  <Trans>Comment</Trans>
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {revenuesRender.map((obj, index) => (
              <TableRow key={index}>
                <TableCell sx={{ px: '40px' }}>
                  <Typography
                    className='form-print-medium-label'
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    <Trans id={obj.key} />
                  </Typography>
                </TableCell>
                <TableCell sx={{ paddingLeft: '20px', paddingRight: '5px' }}>
                  <Typography
                    className='form-print-text'
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    <CurrencyFormated value={obj.value} />
                  </Typography>
                </TableCell>
                <TableCell className='form-print-text' sx={{ px: '40px' }}>
                  <Typography style={{ whiteSpace: 'pre-line' }}>
                    {obj.comment}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter sx={{ backgroundColor: '#EEEEE6' }}>
            <TableRow>
              <TableCell
                sx={{
                  width: '25%',
                  px: '40px',
                  paddingTop: '16px',
                  paddingBottom: '24px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <Trans>SUM_OF_REVENUES</Trans>
                </Typography>
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  width: '25%',
                  paddingLeft: '20px',
                  paddingRight: '40px',
                  paddingTop: '16px',
                  paddingBottom: '24px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <CurrencyFormated value={totalRevenue} maximumFractionDigits={2} />
                </Typography>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: 'block',
          width: 'calc(100% + 32px)',
          height: '16px',
          backgroundColor: '#EEEEE657',
          mx: '-16px'
        }}
      />

      <TableContainer
        component={Box}
        sx={{
          mx: '-16px',
          width: 'calc(100% + 32px)',
          backgroundColor: '#ffffff',
          borderBottom: 'none'
        }}
      >
        <Table
          aria-label='simple table'
          sx={{
            width: '100%',
            tableLayout: 'fixed',
            borderCollapse: 'collapse',
            '& td, & th': {
              borderBottom: '1.5px solid #EEEFE6'
            }
          }}
        >
          <TableHead
            sx={{
              backgroundColor: '#fff',
              borderBottom: '2.5px solid #EEEFE6'
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  width: '25%',
                  px: '40px',
                  paddingTop: '24px',
                  paddingBottom: '16px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <Trans>Expenses</Trans>
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: '25%',
                  paddingLeft: '20px',
                  paddingRight: '5px'
                }}
              >
                <Typography className='form-print-small-label'>
                  <Trans>Value</Trans>
                </Typography>
              </TableCell>
              <TableCell sx={{ width: '50%', px: '40px' }}>
                <Typography className='form-print-small-label'>
                  <Trans>Comment</Trans>
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expensesRender.map((obj, index) => (
              <TableRow key={index}>
                <TableCell sx={{ px: '40px' }}>
                  <Typography
                    className='form-print-medium-label'
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    <Trans id={obj.key} />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    className='form-print-text'
                    sx={{
                      whiteSpace: 'pre-line',
                      paddingLeft: '20px',
                      paddingRight: '5px'
                    }}
                  >
                    <CurrencyFormated value={obj.value} />
                  </Typography>
                </TableCell>
                <TableCell sx={{ px: '40px' }}>
                  <Typography
                    className='form-print-text'
                    style={{ whiteSpace: 'pre-line', minHeight: 21 }}
                  >
                    {obj.comment}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter sx={{ backgroundColor: '#EEEEE6' }}>
            <TableRow>
              <TableCell
                sx={{
                  width: '25%',
                  px: '40px',
                  paddingTop: '16px',
                  paddingBottom: '24px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <Trans>SUM_OF_EXPENSES</Trans>
                </Typography>
              </TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  width: '25%',
                  paddingLeft: '20px',
                  paddingRight: '40px',
                  paddingTop: '16px',
                  paddingBottom: '24px'
                }}
              >
                <Typography className='form-print-big-label'>
                  <CurrencyFormated value={totalExpense} maximumFractionDigits={2} />
                </Typography>
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Box
        sx={{
          display: 'block',
          width: 'calc(100% + 32px)',
          height: '16px',
          backgroundColor: '#EEEEE657',
          mx: '-16px'
        }}
      />
      <Box
        sx={{
          display: 'flex',
          mx: '-16px',
          width: 'calc(100% + 32px)',
          padding: '16px 0',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          backgroundColor: '#17374F'
        }}
      >
        <Typography className='form-print-big-label form-white'>
          <Trans>Total of revenue - expenses</Trans>
        </Typography>
        <Typography className='form-print-big-label form-white'>
          <CurrencyFormated
            value={budgetBalance}
            maximumFractionDigits={2}
          />
        </Typography>
      </Box>
    </Box>
  )
}
